<template>
  <v-flex class="fonte" xs12>
    <div style="min-height: 100vh;" class="expande-horizontal centraliza wrap">
      <v-flex xs12 md7>
        <v-flex class="px-3 mb-3 pt-0 mt-0" xs12>
          <div class="fonte expande-horizontal column">
            <v-list class="pa-0 ma-0" dense>
              <v-list-item class="px-0">
                <v-avatar color="blue" class="mr-2" size="40">
                  <v-icon color="white">{{ current_step.icon }}</v-icon>
                </v-avatar>
                <v-list-item-content>
                  <v-list-item-title style="font-size: 13pt;">
                    {{ current_step.task }}
                  </v-list-item-title>
                  <v-list-item-subtitle>
                    {{ current_step.category }}
                  </v-list-item-subtitle>
                </v-list-item-content>
                <v-list-item-action>
                  <v-btn
                    v-if="time_status == 'running'"
                    @click="pauseCronometer"
                    icon
                  >
                    <v-icon size="40" color="blue"
                      >mdi-pause-circle-outline</v-icon
                    >
                  </v-btn>
                  <v-btn
                    v-if="time_status == 'paused'"
                    @click="resumeCronometer"
                    icon
                  >
                    <v-icon size="40" color="green"
                      >mdi-play-circle-outline</v-icon
                    >
                  </v-btn>
                </v-list-item-action>
              </v-list-item>
            </v-list>
          </div>
        </v-flex>
        <v-spacer></v-spacer>
        <v-window touchless v-model="step">
          <v-window-item value="0">
            <ChoiseStudent
              @input="student => selectStudent(student)"
              v-if="current_step.step == 0"
              v-model="student"
            />
          </v-window-item>
          <v-window-item value="1">
            <div
              class="expande-horizontal centraliza"
              style="min-height: 80vh;"
            >
              <!-- <v-list dense three-line>
                <v-list-item
                  class="mb-4"
                  v-for="(info_evaluation, i) in info_evaluation_values"
                  :key="`i-e-${i}`"
                >
                  <v-avatar
                    size="36"
                    :color="info_evaluation.color"
                    class="mr-2"
                  >
                    <h3>{{ info_evaluation.value }}</h3>
                  </v-avatar>
                  <v-list-item-content>
                    <span class="fonte" style="font-size: 12pt !important;">{{
                      info_evaluation.label
                    }}</span>
                  </v-list-item-content>
                </v-list-item>
              </v-list> -->
              <!-- <v-spacer></v-spacer> -->
              <div>
                <v-btn
                  @click="startEvaluation"
                  color="blue"
                  dark
                  rounded
                  depressed
                  block
                >
                  <span class="fonte">Iniciar avaliação</span>
                  <v-icon>mdi-check</v-icon>
                </v-btn>
              </div>
            </div>
          </v-window-item>
          <v-window-item
            v-for="(_step, index) in steps"
            :key="`step--${index}`"
            :value="_step.step"
          >
            <div style="min-height: 80vh;" class="expande-horizontal wrap">
              <v-flex class="px-2" xs12>
                <div class="expande-horizontal column">
                  <v-card color="#f2f2f2" outlined class="pa-2">
                    <div class="expande-horizontal column">
                      <h3>
                        Progresso - {{ index + 1 }} de {{ steps.length }} -
                        {{ current_step_time_formatted }}
                      </h3>
                      <v-progress-linear
                        color="light-blue"
                        height="10"
                        rounded
                        :value="getProgress(_step.step)"
                        striped
                      ></v-progress-linear>
                    </div>
                  </v-card>
                  <v-card color="#f2f2f2" outlined class="pa-2 mt-3">
                    <div class="expande-horizontal column">
                      <h3>Instrução</h3>
                      <span class="my-2">{{ _step.task }}</span>
                      <span
                        class="red--text font-weight-bold"
                        style="font-size: 16pt;"
                      >
                        <v-icon size="30" color="red">mdi-alert-outline</v-icon>
                        {{ _step.exclusion_warning }}
                      </span>
                    </div>
                  </v-card>
                  <v-card
                    color="#f2f2f2"
                    style="min-height: 20vh;"
                    outlined
                    class="pa-2 mt-3"
                  >
                    <h3>Imagem</h3>
                    <div class="expande-horizontal centraliza column">
                      <img
                        v-if="_step.moviment_description_image"
                        :src="_step.moviment_description_image"
                        alt="imagem"
                        style="height: 200px;"
                      />
                      <!-- <v-icon size="100">mdi-image-outline</v-icon> -->
                    </div>
                  </v-card>
                  <v-card
                    color="#f2f2f2"
                    style="min-height: 12vh;"
                    outlined
                    v-if="_step.showMembersChoise"
                    class="pa-2 mt-3"
                  >
                    <h3>Membro utilizado:</h3>
                    <div
                      style="min-height: 12vh;"
                      class="expande-horizontal centraliza"
                    >
                      <v-btn
                        style="cursor: pointer;"
                        @click="member = 'direito'"
                        class="mr-3 not-selectable"
                        :depressed="member == 'direito' ? false : true"
                      >
                        <h3>Direito</h3>
                      </v-btn>
                      <v-btn
                        style="cursor: pointer;"
                        @click="member = 'esquerdo'"
                        class="mr-3 not-selectable"
                        :depressed="member == 'esquerdo' ? false : true"
                      >
                        <h3>Esquerdo</h3>
                      </v-btn>
                    </div>
                  </v-card>

                  <v-card v-if="_step.showTextField" class="pa-2">
                    <span>{{ _step.textFieldPlaceholder }}</span>
                    <v-text-field
                      outlined
                      v-if="_step.showTextField"
                      v-model="_step.textFieldData"
                      :placeholder="_step.textFieldPlaceholder"
                    ></v-text-field>
                    <span class="mt-3">{{ _step.textFieldPlaceholder2 }}</span>
                    <v-text-field
                      outlined
                      v-if="_step.showTextField2"
                      v-model="_step.textFieldData2"
                      :placeholder="_step.textFieldPlaceholder2"
                    ></v-text-field>
                  </v-card>

                  <v-card
                    color="#f2f2f2"
                    style="min-height: 12vh;"
                    outlined
                    class="pa-2 mt-3"
                    v-if="_step.showPointsChoise"
                  >
                    <h3>Pontuação</h3>
                    <div
                      style="min-height: 12vh;"
                      class="expande-horizontal centraliza"
                    >
                      <v-avatar
                        color="grey"
                        v-if="_step.showPointsChoise[0] === 0"
                        style="cursor: pointer;"
                        @click="nextQuestion(0, index)"
                        size="50"
                        class="mr-3 not-selectable"
                      >
                        <h3>0</h3>
                      </v-avatar>
                      <v-avatar
                        color="grey"
                        v-if="_step.showPointsChoise[1]"
                        style="cursor: pointer;"
                        @click="nextQuestion(1, index)"
                        size="50"
                        class="mr-3 not-selectable"
                      >
                        <h3>1</h3>
                      </v-avatar>
                      <v-avatar
                        v-if="_step.showPointsChoise[2]"
                        style="cursor: pointer;"
                        @click="nextQuestion(2, index)"
                        size="50"
                        color="grey"
                        class="mr-3 not-selectable"
                      >
                        <h3>2</h3>
                      </v-avatar>
                      <v-avatar
                        v-if="_step.showPointsChoise[3]"
                        style="cursor: pointer;"
                        @click="nextQuestion(3, index)"
                        size="50"
                        color="grey"
                        class="mr-3 not-selectable"
                      >
                        <h3>3</h3>
                      </v-avatar>
                    </div>
                  </v-card>
                  <v-card
                    color="#f2f2f2"
                    style="min-height: 12vh;"
                    outlined
                    class="pa-2 mt-3"
                    v-else
                  >
                    <!-- <h3>Avançar</h3> -->
                    <div
                      style="min-height: 12vh;"
                      class="expande-horizontal centraliza"
                    >
                      <v-btn
                        style="cursor: pointer;"
                        @click="nextQuestion(3, index)"
                        class="mr-3 not-selectable"
                      >
                        <h3>Avançar</h3>
                      </v-btn>
                    </div>
                  </v-card>
                </div>
              </v-flex>
            </div>
          </v-window-item>
          <v-window-item value="11">
            <div
              style="min-height: 80vh;max-height: 80vh; overflow: auto;"
              class="expande-horizontal wrap"
            >
              <v-flex class="px-2" xs12>
                <div class="expande-horizontal column">
                  <v-card color="#f2f2f2" outlined class="pa-2">
                    <div class="expande-horizontal column">
                      <h3>
                        Progresso concluído - o tempo total foi de
                        {{ current_step.task }}
                      </h3>
                      <v-progress-linear
                        color="green"
                        height="10"
                        rounded
                        value="100"
                        striped
                      ></v-progress-linear>
                    </div>
                  </v-card>
                  <v-card
                    color="#f2f2f2"
                    style="min-height: 12vh;"
                    outlined
                    class="pa-2 mt-3"
                  >
                    <h3>Resultado</h3>
                    <div
                      style="min-height: 12vh;"
                      class="expande-horizontal centraliza"
                    >
                      <v-list color="transparent">
                        <template v-for="(_step, index) in steps">
                          <v-list-item
                            class="px-3"
                            :key="`step-result-${_step.step}`"
                          >
                            <v-avatar
                              color="#e5e5e5"
                              class="mr-3"
                              rounded
                              size="100"
                            >
                              <v-img v-if="_step.moviment_description_image" :src="_step.moviment_description_image"></v-img>
                              <v-icon v-else>mdi-image-outline</v-icon>
                            </v-avatar>
                            <v-list-item-content>
                              <v-list-item-title>
                                <span
                                  class="fonte"
                                  style="font-size: 12pt !important;"
                                  >Categoria: {{ _step.category }}</span
                                >
                              </v-list-item-title>
                              <span
                                class="fonte"
                                style="font-size: 12pt !important;"
                                >Instrução: {{ _step.task }}</span
                              >
                              <span
                                v-if="_step.showPointsChoise"
                                class="fonte"
                                style="font-size: 12pt !important;"
                                >Nota: {{ _step.evaluation_note }}</span
                              >
                              <span
                                v-if="_step.showMembersChoise"
                                class="fonte"
                                style="font-size: 12pt !important;"
                                >Membro: {{ _step.member }}</span
                              >
                              <span
                                v-if="_step.showTextField"
                                class="fonte"
                                style="font-size: 12pt !important;"
                                >{{ _step.textFieldPlaceholder }}: {{ _step.textFieldData }}</span
                              >
                              <span
                                v-if="_step.showTextField2"
                                class="fonte"
                                style="font-size: 12pt !important;"
                                >{{ _step.textFieldPlaceholder2 }}: {{ _step.textFieldData2 }}</span
                              >
                              <span
                                class="fonte"
                                style="font-size: 12pt !important;"
                                >Tempo:
                                {{ _step.total_step_time_formatted }}</span
                              >
                            </v-list-item-content>
                          </v-list-item>
                          <v-divider :key="index"></v-divider>
                        </template>
                      </v-list>
                    </div>
                  </v-card>
                </div>
              </v-flex>
            </div>
          </v-window-item>
        </v-window>
      </v-flex>
      <v-flex xs12>
        <div class="expande-horizontal centraliza column">
          <v-btn
            v-if="step !== '11'"
            @click="confirmCancelTest"
            text
            x-small
            class="text-lowercase"
            color="orange darken-2"
            >cancelar teste</v-btn
          >
          <v-btn v-else @click="reloadPage" rounded dark color="green"
            >Novo Teste</v-btn
          >
          <v-btn v-if="step == '11'" @click="$router.go(-1)" text rounded
            >Sair</v-btn
          >
        </div>
      </v-flex>
    </div>
  </v-flex>
</template>

<script>
import ChoiseStudent from "@/apps/Student/views/ChoiseStudent.vue";
import { mapActions } from "vuex";
export default {
  components: {
    ChoiseStudent
  },
  computed: {
    stepsPendings() {
      return this.steps.filter(step => step.status == "pending");
    }
  },
  data() {
    return {
      step: "0",
      student: {},
      current_step: {
        step: "0",
        icon: "mdi-account-circle-outline",
        category: "Clique para selecionar",
        task: "Escolha um aluno para avaliar.",
        exclusion_warning: "",
        moviment_description_image: "/img1.png",
        evaluation_note: {},
        total_step_time: 0,
        status: "pre-running" //pending | running | done
      },
      member: "",
      time_status: "ready", //paused | running | ready
      time_total: 0,
      time_current_step: 0,
      current_step_time_formatted: "00:00",
      // info_evaluation_values: [
      //   {
      //     color: "red",
      //     value: 0,
      //     label:
      //       "Indica que a criança não conseguiu realizar a tarefa corretamente ou não conseguiu realizar a tarefa de forma independente."
      //   },
      //   {
      //     color: "orange",
      //     value: 1,
      //     label:
      //       "Indica que a criança conseguiu realizar a tarefa, mas com muita dificuldade ou com ajuda do examinador."
      //   },
      //   {
      //     color: "green lighten-2",
      //     value: 2,
      //     label:
      //       "Indica que a criança realizou a tarefa com facilidade e sem ajuda, mas com algumas imperfeições."
      //   },
      //   {
      //     color: "green",
      //     value: 3,
      //     label:
      //       "Indica que a criança realizou a tarefa com facilidade e sem imperfeições."
      //   }
      // ],
      steps: [
        {
          step: "2",
          category: "Destreza Manual",
          task:
            "(Mão Esquerda) Colocar 12 pinos em uma prancha de madeira com a mão esquerda.",
          exclusion_warning:
            "Pegar mais de um pino de uma só vez ou utilizar ambas as mãos.",
          moviment_description_image: "gifs/manga-male.gif",
          evaluation_note: {},
          member: "",
          showMembersChoise: false,
          showPointsChoise: false,
          total_step_time: 0,
          status: "pending" //pending | running | done
        },
        {
          step: "3",
          category: "Destreza Manual",
          task: "(Mão Direita) Colocar 12 pinos em uma prancha de madeira com a mão direita.",
          exclusion_warning:
            "Pegar mais de um pino de uma só vez ou utilizar ambas as mãos.",
          moviment_description_image: "gifs/manga-male.gif",
          evaluation_note: {},
          member: "",
          showMembersChoise: false,
          showPointsChoise: false,
          total_step_time: 0,
          status: "pending" //pending | running | done
        },
        {
          step: "4",
          category: "Destreza Manual",
          task:
            "Enfiar um cordão em vários furos localizados em uma prancha de costura.",
          exclusion_warning:
            "Errar a sequência lógica de passar o cordão nos furos, esquecer de passar o cordão em algum dos furos ou trocar de mão.",
          moviment_description_image: "gifs/video passando fio gif.gif",
          evaluation_note: {},
          member: "",
          showMembersChoise: true,
          showPointsChoise: false,
          total_step_time: 0,
          status: "pending" //pending | running | done
        },
        {
          step: "5",
          category: "Destreza Manual",
          task: "Contornar pontos tracejados em formato de uma flor.",
          exclusion_warning:
            "Inverter a direção no qual traceja, retirar o lápis e colocar fora do ponto onde parou. Deve ser considerado o número de veze que a criança saiu do limite das duas linhas e permaneceu por uma distância de no mínimo 1/2 polegada.",
          moviment_description_image: "gifs/contornando.gif",
          evaluation_note: {},
          showMembersChoise: true,
          showPointsChoise: [0, 1],
          member: "",
          total_step_time: 0,
          status: "pending" //pending | running | done
        },
        {
          step: "6",
          category: "Habilidades com a bola",
          task:
            "Quicar e pegar a bola de tênis com uma mão *cada mão 10 tentativas.",
          exclusion_warning:
            "Quicar a bola com uma mão e pegar com as duas. Quicar a bola com uma mão e pegar com a outra. Quicar a bola com uma mão e pegar com o auxílio do corpo.",
          moviment_description_image: false,
          evaluation_note: {},
          showMembersChoise: true,
          showPointsChoise: false,
          showTextField: true,
          textFieldData: "",
          textFieldPlaceholder:
            "Quantidade de vezes que pegou a bola com a mão dominante",
          member: "",
          total_step_time: 0,
          status: "pending" //pending | running | done
        },
        {
          step: "7",
          category: "Habilidades com a bola",
          task:
            "Arremessar o saquinho de feijão dentro da caixa (distância de 2 metros).",
          exclusion_warning:
            "Pisar ou ultrapassar a linha limite para o arremesso. Arremessar o saquinho de feijão com as duas mãos.",
          moviment_description_image: "gifs/gif Arremessando.gif",
          evaluation_note: {},
          total_step_time: 0,
          showMembersChoise: true,
          showPointsChoise: false,
          showTextField: true,
          textFieldData: "",
          textFieldPlaceholder:
            "Número de vezes que acertou até 10 vezes com a mão dominante",
          member: "",
          status: "pending" //pending | running | done
        },
        {
          step: "8",
          category: "Equilíbrio estático",
          task: "Equilíbrio em uma perna (equilíbrio da cegonha) *20 segundos.",
          exclusion_warning:
            "Mover o pé de equilíbrio do local original. Afastar o pé que estava no joelho contrário. Tirar as mãos da cintura.",
          moviment_description_image: "gifs/Equilibrio gif.gif",
          evaluation_note: {},
          timer: 20,
          total_step_time: 0,
          status: "pending" //pending | running | done
        },
        {
          step: "9",
          category: "Equilíbrio estático",
          task:
            "Saltar com um dos pés dentro do quadrado consecutivo.",
            //"Saltar com os pés juntos por dentro dos quadrados (45 cm) consecutivos.",
          exclusion_warning:
            "Aterrissar fora do quadrado ou em cima das linhas. Aterrissar com os pés muito distantes um do outro",
          moviment_description_image: "gifs/Saltando.gif",
          evaluation_note: {},
          showPointsChoise: false,
          showTextField: true,
          textFieldData: "",
          textFieldPlaceholder: "Acerto do movimento com o Pé esquerdo",
          showTextField2: true,
          textFieldData2: "",
          textFieldPlaceholder2: "Acerto do movimento com o Pé direito",
          member: "",
          total_step_time: 0,
          status: "pending" //pending | running | done
        },
        {
          step: "10",
          category: "Equilíbrio estático",
          task:
            "Caminhas sobre a linha (4,5 metros de comprimento), um pé em frente ao outro.",
          exclusion_warning:
            "Deixar espaço entre os dedos e o calcanhar pisar fora da linha.",
          moviment_description_image: "gifs/Caminhando em linha reta.gif",
          evaluation_note: {},
          showPointsChoise: false,
          showTextField: true,
          textFieldData: "",
          textFieldPlaceholder: "Número correto de passos que deu (Máx 15)",
          member: "",
          total_step_time: 0,
          status: "pending" //pending | running | done
        },
      ]
    };
  },
  watch: {
    time_current_step: function(value) {
      if (this.current_step && this.current_step.timer) {
        if (value == this.current_step.timer) {
          this.pauseCronometer();
          alert("O tempo máximo foi atingido, o relógio foi pausado!");
        }
      }
    }
  },
  methods: {
    ...mapActions(["createConfirmAction"]),
    reloadPage() {
      location.reload();
    },
    confirmCancelTest() {
      this.createConfirmAction({
        message:
          "Tem certeza que deseja cancelar o teste? Todos os dados serão perdidos.",
        icon: "mdi-close-circle",
        action: () => {
          this.$router.go(-1);
        },
        isScoped: true
      });
    },
    getProgress() {
      const total = this.steps.length;
      const done = this.steps.filter(step => step.status == "done").length;
      return (done / total) * 100;
    },
    selectStudent(student) {
      this.student = student;
      this.current_step = {
        step: 0,
        icon: "mdi-flag-checkered",
        category: "clique no botão abaixo para começar",
        task: "Começar.",
        exclusion_warning: "",
        moviment_description_image: "/img1.png",
        evaluation_note: {},
        total_step_time: 0,
        status: "pre-running" //pending | running | done
      };
      this.step = "1";
    },
    startEvaluation() {
      this.step = "2";
      this.startCronometer();
    },
    nextQuestion(note, index) {
      this.steps[index].evaluation_note = note;
      this.steps[index].status = "done";
      this.steps[index].total_step_time = this.time_current_step;
      this.steps[index].member = this.member;
      this.steps[
        index
      ].total_step_time_formatted = this.current_step_time_formatted;

      const newStep = parseInt(this.steps[index].step) + 1;

      if (newStep == 11) {
        this.step = "11";
        this.pauseCronometer();
        this.registerEvaluation();
        return;
      }

      this.step = `${newStep}`;
      this.time_current_step = 0;
      this.member = "";
      this.pauseCronometer();
    },
    registerEvaluation() {
      const evaluation = {
        student: this.student._id,
        steps: this.steps,
        time_total: this.time_total
      };
      this.$run("evaluation/create", evaluation);
    },
    cronometer() {
      if (this.time_status == "running") {
        this.time_current_step++;
        this.time_total++;

        const minutes_current_step = Math.floor(this.time_current_step / 60);
        const seconds_current_step = this.time_current_step % 60;

        const minutes = Math.floor(this.time_total / 60);
        const seconds = this.time_total % 60;
        const formattedTime =
          (minutes < 10 ? "0" : "") +
          minutes +
          ":" +
          (seconds < 10 ? "0" : "") +
          seconds;
        const formattedTimeCurrentStep =
          (minutes_current_step < 10 ? "0" : "") +
          minutes_current_step +
          ":" +
          (seconds_current_step < 10 ? "0" : "") +
          seconds_current_step;

        this.current_step_time_formatted = formattedTimeCurrentStep;
        this.current_step = {
          icon: "mdi-play-circle-outline",
          category: "tempo total",
          task: formattedTime,
          exclusion_warning: "",
          moviment_description_image: "/img1.png",
          evaluation_note: {},
          total_step_time: formattedTimeCurrentStep,
          status: "pre-running" //pending | running | done
        };
        setTimeout(() => {
          this.cronometer();
        }, 1000);
      }
    },
    startCronometer() {
      this.time_status = "running";
      this.cronometer();
    },
    pauseCronometer() {
      this.time_status = "paused";
    },
    resumeCronometer() {
      this.time_status = "running";
      this.cronometer();
    }
  }
};
</script>
